module.exports = __webpack_public_path__ + "media/application/images/svgs/logo-9df49c8d334a9fcad6d50a6b286cdd5f.svg";